// extracted by mini-css-extract-plugin
export default {"search":"Search_search__+anZW","table":"Search_table__gLbz4","procedure":"Search_procedure__wjiut","loader":"Search_loader__tOxRj"};